/**
 * Redux global states
 */

export default {
  globalName: 'index page',
  globalPopStatus: {
    role: false,
  },
}
